import {
  Node_Type,
  PluginContainerData_Alignment,
  PluginContainerData_Width_Type
} from "./../ricos-schema/legacy/wix/rich_content/v1";
const VIDEO_INSERT_VIDEO_MODAL_ID = "VIDEO.insertVideo";
const VIDEO_INSERT_YOUTUBE_MODAL_ID = "VIDEO.insertYoutube";
const VIDEO_REPLACE_MODAL_ID = "VIDEO.replace";
const VIDEO_SETTINGS_MODAL_ID = "VIDEO.settings";
const VIDEO_BUTTONS = {
  alignment: `${Node_Type.VIDEO}.alignment`,
  size: `${Node_Type.VIDEO}.size`
};
const pauseTrigger = { scroll: "scroll" };
const RICOS_DEFAULTS = {
  containerData: {
    alignment: PluginContainerData_Alignment.CENTER,
    width: {
      size: PluginContainerData_Width_Type.CONTENT
    },
    textWrap: true
  }
};
export {
  RICOS_DEFAULTS,
  VIDEO_BUTTONS,
  VIDEO_INSERT_VIDEO_MODAL_ID,
  VIDEO_INSERT_YOUTUBE_MODAL_ID,
  VIDEO_REPLACE_MODAL_ID,
  VIDEO_SETTINGS_MODAL_ID,
  pauseTrigger
};
//# sourceMappingURL=constants.js.map
